import React from 'react';
import tw from 'twin.macro';

interface Props {
  children: [React.ReactNode, React.ReactNode];
}

export function BodyAndSidebar(props: Props) {
  const { children } = props;
  return (
    <main
      css={[
        tw`flex-1 relative overflow-y-auto focus:outline-none`,
        // C'est éviter que l outline des input soit coupé en bordure
        tw`overflow-x-visible`,
      ]}
    >
      <div tw="mx-auto md:grid md:grid-cols-5 p-0.5">
        <div tw="md:col-span-4 md:pr-4 md:border-r md:border-neutral-quiet">
          {children[0]}
        </div>
        {children[1]}
      </div>
    </main>
  );
}
